import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getData, postData, putData } from '../../actions/servicesHttp'
import ModalGeneric from './modal'
import DataTableDemo from '../generals/datatables/datatable'
import PropTypes from 'prop-types'
import FormDenunciation from './formDenunciation'
import { popupSimple } from '../generals/popups'
import $ from 'jquery'
import store from '../../reducer/store'
import Loading from '../generals/loading'
import { useTranslation } from 'react-i18next'

export default function ModalInforms ({ show, onHide, device }) {
  // console.log(onHide, show, device)
  const { id } = useParams()
  const { user } = store.getState()
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()

  // ? urls de la API
  const [lossReportsUrl] = useState('device/loss_reports')
  const [trackingUrl] = useState('allTrackings')
  const [denunciationUrl] = useState('denunciation')

  //* estados de componentes
  const [reports, setReports] = useState({
    cases: null,
    ticket: null,
    denunciation: {
      incidentDate: null,
      denunciationDate: null,
      denunciationNumber: null,
      investigator: null,
      file: null,
      fileExtension: null,
      recoveryDate: null
    },
    orderId: null
  })
  const [modal, setModal] = useState({
    tracking: false,
    denunciation: false
  })
  const [file, setFile] = useState(null)
  const [errorDenunciation, setErrorDenunciation] = useState(false)
  const [mode, setMode] = useState('empty')
  const [loading, setLoading] = useState(true)

  //* llamador de datos de API
  const getRequest = async (url, data) => {
    const response = await getData(url, data, navigate)
    // console.log(response, url)
    if (response.status === 200) {
      sanitizationData(response.data)
    } else {
      console.log({ error: true, code: response.code })
    }
  }

  useEffect(() => {
    if (show) getRequest(lossReportsUrl, id)
  }, [lossReportsUrl, id, show])

  const sanitizationData = (data) => {
    const formatData = data.map(info => {
      // console.log(info)
      const dateOrder = !info.start_date
        ? t('modalInforms.label1')
        : new Date(info.start_date).toLocaleString('es-AR', { hour12: false })
      const dateFinish = !info.finish_date
        ? t('modalInforms.label2')
        : new Date(info.finish_date).toLocaleString('es-AR', { hour12: false })

      info.start_date = dateOrder
      info.finish_date = dateFinish

      if (info?.user === null) info.user = { user: 'System' }
      return info
    })
    setReports({
      ...reports,
      cases: formatData
    })
  }

  const viewTicket = async (info) => {
    let array = []
    const trackingId = info?.trackingId
    const { data } = await getData(trackingUrl, trackingId, navigate)

    if (data && data.length > 0) {
      array = data[0].tracking
      array?.forEach((element) => {
        if (!element.place) element.place = t('modalInforms.noDisponible')
      })
    }

    setReports({
      ...reports,
      ticket: array
    })
    onHide()
    setModal({ ...modal, tracking: true })
  }

  const viewDenunciation = async (info) => {
    if (info?.denunciationId) {
      const denunciationId = info?.denunciationId
      const res = await getData(denunciationUrl, denunciationId, navigate)

      const denunciation = res?.data
      denunciation.recoveryDate = denunciation.recoveryDate === null ? t('modalInforms.noDisponible') : denunciation.recoveryDate
      denunciation.denunciationStatus = denunciation.denunciationStatus === 'open' ? t('modalInforms.label3') : denunciation.denunciationStatus === 'monitoring' ? t('modalInforms.label4') : t('modalInforms.label5')

      setReports({
        ...reports,
        orderId: info?.order_id,
        denunciation
      })
    } else {
      setReports({
        ...reports,
        orderId: info?.order_id
      })
    }

    setLoading(false)
    onHide()
    setModal({ ...modal, denunciation: true })
  }

  function handleOnChangeDenunciation (e) {
    if (e?.target.id === 'denunciationStatus') {
      setReports({
        ...reports,
        denunciation: {
          ...reports.denunciation,
          [e.target.id]: e.target.value.name
        }
      })
    } else {
      setReports({
        ...reports,
        denunciation: {
          ...reports.denunciation,
          [e.target.id]: e.target.value
        }
      })
    }
  }

  function inputFileHandling () {
    const input = document.querySelector('#denunciationFile')

    input.addEventListener('change', e => {
      const span = document.querySelector('#file_name_document')

      if (input?.files?.length === 0) {
        span.innerHTML = t('modalInforms.label6')
      } else if (input?.files?.length > 0) {
        span.innerHTML = input.files[0].name
        const extension = input.files[0].name.split('.').pop()
        setReports({
          ...reports,
          denunciation: {
            ...reports.denunciation,
            file: input.files[0].name,
            fileExtension: extension
          }
        })
        setFile(input.files)
      }
    })
  }

  const validationDenunciation = (data, set, mode) => {
    let flag = false
    const dataToValidate = data
    if (mode === 'upload') {
      delete dataToValidate?.recoveryDate
      flag = Object.values(dataToValidate).some(value => (value === null || value === ''))
      set(flag)
    }

    if (mode === 'edit') {
      for (const key in data) {
        if (data[key] === '') {
          data[key] = null
        }
      }
    }

    return flag
  }

  const uploadDenunciationFile = async () => {
    let res
    const f = new FormData()

    if (file !== null) {
      for (let i = 0; i < file.length; i++) {
        const extension = file[i].name.split('.').pop()
        const newName = device?.licence + '_' + reports.denunciation?.denunciationNumber + '.' + extension // Cambia el nombre y mantiene la extensión
        const newFile = new File([file[i]], newName, { type: file[i].type })
        f.append('files', newFile)
      }

      const response = await postData('upload/denunciations', f, navigate)

      if (response.status === 200) {
        setFile(null)
        res = true
      } else {
        popupSimple('error', t('modalInforms.label7'))
        res = false
      }
    } else {
      popupSimple('info', t('modalInforms.label8'))
      res = false
    }
    return res
  }

  function closeModal () {
    onHide()
    setModal({ ...modal, denunciation: false })
    setFile(null)
    setReports({
      ...reports,
      denunciation: {
        incidentDate: null,
        denunciationDate: null,
        denunciationNumber: null,
        investigator: null,
        file: null,
        fileExtension: null,
        recoveryDate: null
      },
      orderId: null
    })
    setErrorDenunciation(false)
    setTimeout(() => {
      setMode('empty')
    }, 2000)
  }

  async function sendDenunciation (mode) {
    $('#btnModalSucess').prop('disabled', true)
    const denunciationFlag = validationDenunciation(reports.denunciation, setErrorDenunciation, mode)

    if (denunciationFlag) {
      setTimeout(() => {
        $('#btnModalSucess').prop('disabled', false)
      }, 1500)
    } else {
      if (mode === 'upload') {
        let upload = true
        upload = await uploadDenunciationFile()

        if (!upload) {
          closeModal()
          setTimeout(() => {
            $('#btnModalSucess').prop('disabled', false)
          }, 1500)
          return
        }
      }
      let response

      if (mode === 'upload') {
        response = await postData('denunciations', { ...reports.denunciation, deviceId: device?.id, userId: user.userId, orderId: reports.orderId }, navigate)
        if (response?.status === 200) {
          popupSimple('success', t('modalInforms.label10'))
        }
        if (response?.error) {
          popupSimple('error', t('modalInforms.label11'))
        }
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
        closeModal()
      } else if (mode === 'editStatus') {
        const json = {
          denunciationStatus: reports.denunciation?.denunciationStatus === t('modalInforms.label4') ? 'monitoring' : reports.denunciation?.denunciationStatus === t('modalInforms.label5') ? 'close' : 'open',
          id: reports.denunciation.id
        }
        if (reports.denunciation?.denunciationStatus === t('modalInforms.label5')) {
          json.closeUserId = user?.userId
          json.closeDate = new Date().toISOString()
        }

        response = await putData('denunciations', json, navigate)
        if (response?.status === 200) {
          popupSimple('success', t('modalInforms.label12'))
        } else {
          popupSimple('error', t('modalInforms.label13'))
        }
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
        closeModal()
      } else if (mode === 'edit') {
        const json = {
          denunciationStatus: reports.denunciation?.denunciationStatus === t('modalInforms.label4') ? 'monitoring' : reports.denunciation?.denunciationStatus === t('modalInforms.label5') ? 'close' : 'open',
          id: reports.denunciation.id,
          denunciationDate: reports.denunciation?.denunciationDate,
          incidentDate: reports.denunciation?.incidentDate,
          recoveryDate: reports.denunciation?.recoveryDate === t('modalInforms.noDisponible') ? null : reports.denunciation?.recoveryDate,
          investigator: reports.denunciation?.investigator
        }

        if (reports.denunciation?.denunciationStatus === t('modalInforms.label5')) {
          json.closeUserId = user?.userId
          json.closeDate = new Date().toISOString()
        }

        response = await putData('denunciations', json, navigate)
        if (response?.status === 200) {
          popupSimple('success', t('modalInforms.label12'))
        } else {
          popupSimple('error', t('modalInforms.label13'))
        }
        setTimeout(() => {
          $('#btnModalSucess').prop('disabled', false)
        }, 1500)
        closeModal()
      }
    }
  }

  return (
    <>
      {/* MODAL DE HISTORIAL DE ROBOS */}
      <ModalGeneric
        show={show}
        onHide={onHide}
        size="xl"
        id="cases"
        onClose={onHide}
        title={t('modalInforms.title1')}
        btnError={t('modalInforms.button1')}
        btnSuccess={t('modalInforms.button2')}
        viewBtnSuccess={false}
      >
        <DataTableDemo
          data={reports.cases}
          table="cases"
          rowSelecteds={false}
          rowStates={false}
          exportsCsv={true}
          exportsPdf={true}
          actionDashboard={false}
          actionDelete={false}
          viewBtnAction={false}
          link={false}
          actionBlockCases={viewTicket}
          actionDenunciation={viewDenunciation}
          searchs={['order_id']}
          editUsers={false}
          namePdf={t('modalInforms.namePdf1')}
          columns={[
            {
              field: 'order_id',
              header: t('modalInforms.headers1.one')
            },
            {
              field: 'start_date',
              header: t('modalInforms.headers1.two')
            },
            {
              field: 'finish_date',
              header: t('modalInforms.headers1.three')
            },
            {
              field: 'user.user',
              header: t('modalInforms.headers1.four')
            }
          ]}
        />
      </ModalGeneric>

       {/* MODAL DE TICKET DE ROBO */}
       <ModalGeneric
        show={modal.tracking}
        onHide={() => setModal({ ...modal, tracking: false })}
        size="xl"
        id="tracking"
        onClose={() => setModal({ ...modal, tracking: false })}
        title={t('modalInforms.title2')}
        btnError={t('modalInforms.button1')}
        btnSuccess={t('modalInforms.button2')}
        viewBtnSuccess={false}
      >
        <DataTableDemo
          data={reports.ticket}
          table="tickets"
          rowSelecteds={false}
          rowStates={false}
          exportsCsv={true}
          exportsPdf={true}
          actionDashboard={false}
          actionDelete={false}
          searchs={['order_id']}
          editUsers={false}
          columns={[
            {
              field: 'place',
              header: t('modalInforms.headers2.one')
            },
            {
              field: 'lat',
              header: t('modalInforms.headers2.two')
            },
            {
              field: 'lon',
              header: t('modalInforms.headers2.three')
            },
            {
              field: 'acc',
              header: t('modalInforms.headers2.four')
            },
            {
              field: 'ip_lan',
              header: t('modalInforms.headers2.five')
            },
            {
              field: 'ip_wan',
              header: t('modalInforms.headers2.six')
            }
          ]}
        />
      </ModalGeneric>

      {/* MODAL DE DENUNCIAS */}
      <ModalGeneric
        show={modal.denunciation}
        onHide={() => setModal({ ...modal, denunciation: false })}
        size="lg"
        id="denunciations"
        onClose={() => closeModal()}
        title={t('modalInforms.title3')}
        btnError={t('modalInforms.button1')}
        viewBtnSuccess={mode !== 'read'}
        btnSuccess={t('modalInforms.button3')}
        actionSuccess={() => sendDenunciation(mode)}
      >
        {loading && <Loading color="primary" />}
        <FormDenunciation
          data={reports?.denunciation}
          setData={handleOnChangeDenunciation}
          setFile={inputFileHandling}
          mode={mode}
          setMode={setMode}
          errorDenunciation={errorDenunciation}
          loading={loading}
        />
      </ModalGeneric>
    </>
  )
}

ModalInforms.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  device: PropTypes.object
}
